//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadurl_post, changeHeicToJpg_post, getOssPolicy, completeOssUpload } from '@/service/vioReport'
// import { notify } from '../config'
import {isJCSS} from '../../../utils/utils'
export default {
  components: {
    //
  },
  // name: 'upload',
  props: {
    value: { type: Array }, // [{name: '', url: '', state: '']]
    type: { type: String, default: 'picture' }, // picture
    action: { type: String, required: true },
    multiple: { type: Boolean, default: false },
    accept: { type: String, default: '*/*' },
    maxSize: { type: Number, default: 10 * 1024 * 1024 }, // MB，OSS直传图片上限10MB，视频由调用方传50MB
    withCredentials: { type: Boolean, default: false }, // http ..
    preview: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }, // 是否展示上传过程中的菊花
    headers: { type: Object }, // http headers
    data: { type: Object }, // http data
    name: { type: String, default: 'file' },
    onStart: { type: Function, default: (file) => {} },
    onProgress: { type: Function, default: () => {} },
    onSuccess: { type: Function, default: () => {} },
    onError: { type: Function, default: () => {} },
    formatUrlFromResponse: { type: Function, default: (res) => res }
  },
  data () {
    return {
      previewShow: false,
      previewUrl: '',
      reqs: {},
      uploadingFiles: [], // 选择上传的文件列表
      isLoading: false // 选择上传的文件列表
    }
  },
  computed: {
    allFiles () {
      if (this.type === 'picture') {
        return Array.from(this.value).concat(this.uploadingFiles)
      }
      return Array.from(this.uploadingFiles).concat(this.value)
    }
  },
  methods: {
    removeFile (index) {
      if (this.uploadingFiles.length > 0) {
        this.abort(this.uploadingFiles[index], index)
        this.uploadingFiles.splice(index, 1)
      }
      this.emitChange(this.value.filter((f, i) => i !== index))
    },
    clickHandler () {
      // 只有警察叔叔环境拍照用警察叔叔的拍照组件
      if (this.accept.indexOf('video') > -1 || !isJCSS()) {
        this.$refs.input.click()
      } else {
        // eslint-disable-next-line no-undef
        ZWJSBridge.chooseImage({
          upload: true
        })
          .then((result) => {
            let type = ''
            console.log(result, '00000000')
            // if (result.picSrc) {
            //   const arr = result.picSrc[0].split(";")[0];
            //   type = arr.split("/")[1];
            // }
            const img = result.picPath[0]
            console.log(img, '00000000')
            // console.log(result.picSrc[0], "tupian");
            // let file = this.base64ToFile(result.picSrc[0], "图片");
            this.postIMg(img, type)
          })
          .catch((error) => {
            console.log(error)
            this.$refs.input.click()
          })
      }

      // this.$refs.input.click()
    },
    previewHandler (file) {
      if (this.type === 'picture' && this.preview) {
        this.previewUrl = file.url
        this.previewShow = true
      }
    },
    async changeHandler (evt) {
      if (this.reqs.length > 0) return
      let files = evt.target.files
      if (!files) return
      files = Array.from(files)
      if (!this.multiple) files = [files[0]]
      if (files.length <= 0) return
      if (files[0].size > this.maxSize) {
        this.onError('文件过大，请选择较小的文件！')
        return
      }
      // HEIC文件转换处理
      try {
        const processedFiles = await Promise.all(files.map(file => this.processHeicFile(file)))
        this.uploadingFiles = processedFiles
        processedFiles.forEach((file) => {
          file.state = 'progress'
        })
        processedFiles.forEach((file, index) => {
          this.upload(file, index)
        })
      } catch (e) {
        console.error('HEIC图片转换失败', e)
        this.onError('HEIC图片转换失败，请重试！')
      }
    },
    /**
     * 判断是否为HEIC文件
     */
    isHeicFile (file) {
      const name = file.name.toLowerCase()
      return name.endsWith('.heic') || name.endsWith('.heif')
    },
    /**
     * 处理HEIC文件，调用接口转换为JPG
     */
    async processHeicFile (file) {
      if (!this.isHeicFile(file)) return file
      const formData = new FormData()
      formData.append('file', file)
      this.$vux.loading.show({
        text: '正在上传...'
      })
      const res = await changeHeicToJpg_post({ data: formData })
      this.$vux.loading.hide()
      console.log(res, '00000000')
      // 接口返回jpg图片流(blob)，直接转为File对象
      const jpgBlob = res.data
      const jpgFileName = file.name.replace(/\.heic$/i, '.jpg').replace(/\.heif$/i, '.jpg')
      return new File([jpgBlob], jpgFileName, { type: 'image/jpeg' })
    },
    upload (file, index) {
      this.$refs.input.value = null
      this.post(file, index)
    },
    abort (file, id) {
      if (this.reqs[id]) {
        this.reqs[id].abort()
      }
    },
    postIMg (file, id) {
      if (this.loading) {
        this.isLoading = true
      }
      this.onStart()
      // let today = new Date().toLocaleDateString().split('/').map(item => { if (item < 10) { return '0' + item } else { return item } }).join('')
      const data = {
        url: file
      }
      console.log('up666loadPic0000000')
      uploadurl_post(data)
        .then((res) => {
          //    this.isLoading = false
          // console.log(res, 'uploadPic0000000')
          this.isLoading = false
          // const dd = {
          //   url: file,
          //   name: data.pathname + '/' + data.fileName
          // }
          // res.data.data = dd
          console.log(res, 'uploadPivvvvc0000000')
          this.onSuccess(res.data)
          console.log(res, 'uploadPi7777vvvvc0000000')
        })
        .catch((err) => {
          console.log(err)
          this.isLoading = false
          this.onError(err)
        })

      // previewFile(file, (result) => {
      //   file._url = result;
      // });
      // const options = {
      //   headers: this.headers,
      //   withCredentials: this.withCredentials,
      //   file: file,
      //   data: this.data,
      //   filename: this.name,
      //   action: this.action,
      //   onProgress: (e) => {
      //     file.percent = parseInt(e.percent);
      //     this.uploadingFiles.splice(id, 1, file);
      //     this.onProgress(e, file);
      //   },
      //   onSuccess: (res) => {
      //     delete this.reqs[id];
      //     file.state = "done";
      //     file.url = this.formatUrlFromResponse(res);
      //     this.uploadingFiles.splice(id, 1, file);
      //     this.isLoading = false;
      //     this.onSuccess(res, file);
      //     if (Object.keys(this.reqs).length <= 0) {
      //       let nValue = Array.from(this.value);
      //       this.uploadingFiles.forEach((f) => {
      //         if (f.state === "done") {
      //           nValue.push({ name: f.name, url: f.url, _url: f._url });
      //         }
      //       });
      //       this.uploadingFiles = [];
      //       this.emitChange(nValue);
      //     }
      //   },
      //   onError: (err, res) => {
      //     file.state = "error";
      //     this.uploadingFiles.splice(id, 1, file);
      //     this.isLoading = false;
      //     this.onError(err, res, file);
      //     delete this.reqs[id];
      //   },
      // };
      // const req = ajax(options);
      // this.reqs[id] = req;
      // if (req && req.then) {
      //   req.then(options.onSuccess, options.onError);
      // }
    },
    post (file, id) {
      if (this.loading) {
        this.isLoading = true
      }
      this.onStart(file)
      previewFile(file, (result) => {
        file._url = result
      })
      // 第一步：获取直传签名
      getOssPolicy({
        data: {
          suffix: this.getFileSuffix(file)
        }
      })
        .then((response) => {
          const result = response.data
          if (result.code === 200 && result.data) {
            // 第二步：FormData 直传 OSS（file 必须放最后）
            this.uploadToOss(result.data, file, id)
          } else {
            this.handleError(id, file, result.msg || '获取上传凭证失败')
          }
        })
        .catch(() => {
          this.handleError(id, file, '获取上传凭证失败')
        })
    },
    /**
     * 获取文件后缀（大小写不敏感，不带点）
     */
    getFileSuffix (file) {
      const name = file.name || ''
      const idx = name.lastIndexOf('.')
      if (idx > -1) {
        return name.substring(idx + 1)
      }
      const type = file.type || ''
      return type.split('/')[1] || ''
    },
    /**
     * 直传 OSS，成功后调用 /complete 完成核验
     */
    uploadToOss (policy, file, id) {
      const fd = new FormData()
      fd.append('key', policy.key)
      fd.append('policy', policy.policy)
      fd.append('x-oss-signature-version', policy['x-oss-signature-version'])
      fd.append('x-oss-credential', policy['x-oss-credential'])
      fd.append('x-oss-date', policy['x-oss-date'])
      fd.append('x-oss-signature', policy['x-oss-signature'])
      fd.append('success_action_status', policy['success_action_status'])
      fd.append('Content-Type', file.type)
      fd.append('file', file)

      const xhr = new XMLHttpRequest()
      xhr.upload.onprogress = (e) => {
        if (e.total > 0) {
          e.percent = e.loaded / e.total * 100
        }
        file.percent = parseInt(e.percent)
        this.uploadingFiles.splice(id, 1, file)
        this.onProgress(e, file)
      }
      xhr.onerror = () => {
        this.handleError(id, file, '网络异常，上传失败')
      }
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 第三步：完成核验，返回文件id
          completeOssUpload({
            data: {
              key: policy.key,
              fileName: file.name
            }
          })
            .then((response) => {
              const result = response.data
              if (result.code === 200 && result.data) {
                this.handleSuccess(id, file, result)
              } else {
                this.handleError(id, file, result.msg || '文件核验失败')
              }
            })
            .catch(() => {
              this.handleError(id, file, '文件核验失败')
            })
        } else {
          this.handleError(id, file, this.parseOssError(xhr))
        }
      }
      xhr.open('post', policy.host, true)
      xhr.send(fd)
      this.reqs[id] = xhr
    },
    /**
     * 解析 OSS 直传失败返回的 XML 错误信息
     */
    parseOssError (xhr) {
      const text = xhr.responseText || xhr.response || ''
      const m = /<Message>([\s\S]*?)<\/Message>/.exec(text)
      if (m) {
        return m[1]
      }
      return `上传失败(${xhr.status})`
    },
    handleSuccess (id, file, result) {
      delete this.reqs[id]
      file.state = 'done'
      file.url = this.formatUrlFromResponse(result)
      this.uploadingFiles.splice(id, 1, file)
      this.isLoading = false
      this.onSuccess(result, file)
      if (Object.keys(this.reqs).length <= 0) {
        let nValue = Array.from(this.value)
        this.uploadingFiles.forEach((f) => {
          if (f.state === 'done') {
            nValue.push({ name: f.name, url: f.url, _url: f._url })
          }
        })
        this.uploadingFiles = []
        this.emitChange(nValue)
      }
    },
    handleError (id, file, msg) {
      delete this.reqs[id]
      file.state = 'error'
      this.uploadingFiles.splice(id, 1, file)
      this.isLoading = false
      this.onError(msg, null, file)
    },
    emitChange (v) {
      this.$emit('input', v)
      // notify.field.change(this)
    }
  }
}

const previewFile = (file, callback) => {
  const reader = new FileReader()
  reader.onloadend = () => callback(reader.result)
  reader.readAsDataURL(file)
}



// WEBPACK FOOTER //
// ./src/components/common/upload/upload.vue